import { DB_TYPE } from '@/common/define/common.define';
import { USER_ENV_KEYS } from '@/common/define/userEnv.define';
import type { MetricGroup } from './overview.types';

export const OVERVIEW_TYPE = {
  SINGLE_VIEW: 'singleView',
  MULTI_VIEW: 'multiView',
  CLUSTER_VIEW: 'clusterView',
} as const;

export const ENV_KEYS = {
  [DB_TYPE.MYSQL]: {
    [OVERVIEW_TYPE.MULTI_VIEW]: {
      SLOW_QUERY_OPTION: USER_ENV_KEYS.MYSQL_MULTI_VIEW_SLOW_QUERY_OPTION,
      METRIC_CHART_NAMES: USER_ENV_KEYS.MYSQL_METRIC_CHART_METRIC_NAMES,
      OVERVIEW_METRIC_NAMES: USER_ENV_KEYS.MYSQL_MULTI_VIEW_OVERVIEW_METRIC_NAMES,
    },
    [OVERVIEW_TYPE.SINGLE_VIEW]: {},
  },
  [DB_TYPE.POSTGRESQL]: {
    [OVERVIEW_TYPE.MULTI_VIEW]: {
      SLOW_QUERY_OPTION: USER_ENV_KEYS.POSTGRESQL_MULTI_VIEW_SLOW_QUERY_OPTION,
      METRIC_CHART_NAMES: USER_ENV_KEYS.POSTGRESQL_METRIC_CHART_METRIC_NAMES,
      OVERVIEW_METRIC_NAMES: USER_ENV_KEYS.POSTGRESQL_MULTI_VIEW_OVERVIEW_METRIC_NAMES,
    },
    [OVERVIEW_TYPE.SINGLE_VIEW]: {},
  },
};

export const MYSQL_DEFAULT_METRIC_GROUP: MetricGroup[] = [
  {
    metricGroupName: 'Logical + Physical IO',
    type: 'mysql',
    metricNames: ['db_mysql_innodb_buffer_pool_reads', 'db_mysql_innodb_buffer_pool_read_requests'],
  },
];

export const POSTGRESQL_DEFAULT_METRIC_GROUP: MetricGroup[] = [
  {
    metricGroupName: 'Logical + Physical IO',
    type: 'postgresql',
    metricNames: ['db_postgresql_blkshit', 'db_postgresql_blksread'],
  },
  {
    metricGroupName: 'Dml Rows',
    type: 'postgresql',
    metricNames: [
      'db_postgresql_tupreturned',
      'db_postgresql_tupfetched',
      'db_postgresql_tupinserted',
      'db_postgresql_tupupdated',
      'db_postgresql_tupdeleted',
    ],
  },
];
